import { render, staticRenderFns } from "./last-buy.popover.vue?vue&type=template&id=1d067f11&scoped=true"
import script from "./last-buy.popover.vue?vue&type=script&lang=js"
export * from "./last-buy.popover.vue?vue&type=script&lang=js"
import style0 from "./last-buy.popover.vue?vue&type=style&index=0&id=1d067f11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d067f11",
  null
  
)

export default component.exports